import PropTypes from 'prop-types'
import styled from 'styled-components'
import supportsWebP from 'supports-webp'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

import MainBackground4KWebp from 'assets/img/MainBG3840x2160.webp'
import MainBackground4KJpg from 'assets/img/MainBG3840x2160.jpg'
import MainBackground2KWebp from 'assets/img/MainBG2560x1440.webp'
import MainBackground2KJpg from 'assets/img/MainBG2560x1440.jpg'
import MainBackgroundFHDWebp from 'assets/img/MainBG1920x1080.webp'
import MainBackgroundFHDJpg from 'assets/img/MainBG1920x1080.jpg'

import logoImg from 'assets/img/relay_logo.svg'

import LoadingIndicator from 'components/Shared/LoadingIndicator/Index'
import Select from 'components/Shared/Select/Index'
import Button from 'components/Shared/Button/Index'
import Footer from 'components/App/Footer/Index'
import colors from 'components/utils/colors'
import { capitalizeFirstLetter } from 'utils/strings'

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  background-color: #F0F0F0;
  @media (max-width: 1920px) {
    background-image: url(${supportsWebP ? MainBackgroundFHDWebp : MainBackgroundFHDJpg});
  }
  @media (min-width: 1921px) and (max-width: 2560px) {
    background-image: url(${supportsWebP ? MainBackground2KWebp : MainBackground2KJpg});
  }
  @media (min-width: 2561px) {
    background-image: url(${supportsWebP ? MainBackground4KWebp : MainBackground4KJpg});
  }
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-bottom: 140px;
`

const StyledLogo = styled.div`
  width: 212px;
  height: 276px;
  background: url(${logoImg}) no-repeat;
  background-size: cover;
  margin-bottom: 76px;
`

const StyledFormContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 224px;
`

const StyledHeader = styled.div`
  color: ${colors.secondary20};
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
`

const StyledButton = styled(Button)`
  margin-top: 8px;
`

const SignInForm = ({ publicPartners }) => {
  const [selectedPartnerId, setSelectedPartnerId] = useState(localStorage.getItem('last_signed_in_partner_id'))
  const [loading, setLoading] = useState(false)

  const { t } = useTranslation()

  const onPartnerSelect = (value) => {
    setSelectedPartnerId(value)
  }

  const getPartnersOptions = () => {
    return publicPartners.map(p => ({ value: p.id, name: capitalizeFirstLetter(p.name) }))
  }

  const onSignIn = () => {
    setLoading(true)
    const selectedPartner = publicPartners.find(p => p.id === selectedPartnerId)
    sessionStorage.setItem('partnerId', selectedPartnerId)
    window.location.href = `${selectedPartner.authUrl}&continue=${process.env.AUTH_CONTINUE}`
  }

  return (
    <StyledWrapper>
      <LoadingIndicator loading={loading} />
      <StyledLogo />
      <StyledFormContent>
        <StyledHeader>{t('signInPanel.title')}</StyledHeader>
        <Select
          value={selectedPartnerId}
          onChange={onPartnerSelect}
          options={getPartnersOptions()}
        />
        <StyledButton
          large
          onClick={onSignIn}
          disabled={!selectedPartnerId}
          width='100%'
        >
          {t('signInPanel.signIn')}
        </StyledButton>
      </StyledFormContent>

      <Footer />
    </StyledWrapper>
  )
}

SignInForm.propTypes = {
  publicPartners: PropTypes.array,
}

export default SignInForm
